import { Box, Container, Link, Theme, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useHistory } from "react-router-dom";

import NotFoundImg from "assets/images/not-found.svg";

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontSize: 52,
    lineHeight: 1.458,
    letterSpacing: 0.25,
    [theme.breakpoints.down('md')]: {
      fontSize: 42,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 36,
    },
  },
  desc: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
      lineHeight: "26.24px",
    },
  },
}));

const NotFound = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Container id="404-page">
      <Box
        mt={{ xs: 1.5, sm: 3, lg: 5 }}
        mb={{ xs: 4, sm: 5, md: 7 }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Typography className={classes.title} variant="h1" align="center">
          Sorry, we can't find that page.
        </Typography>

        <Box my={4}>
          <img src={NotFoundImg} alt="Not Found" />
        </Box>

        <Typography
          variant="h2"
          align="center"
          display="block"
          className={classes.desc}
        >
          It appears the page you are looking for does not exist.
        </Typography>
        <Typography variant="h2" align="center" className={classes.desc}>
          Please try searching our catalog or return to our{" "}
          <Link onClick={() => history.push("/")}>homepage.</Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default NotFound;
